import 'styles/page/timeline.page.css';
import { useState } from 'react';
import Navigation from 'components/navigation/navigation';
import LoadingScreen from 'components/loading.screen';
import HistoryPanel from './panels/history.panel';
import ActivityPanel from './panels/activity.panel';
import MilestonesPanel from './panels/milestones.panel';
import SideDrawer from 'components/drawers/side.drawer';
import EditPanel from 'components/edit/edit.panel';
import { useData } from 'context/data.context';

const Timeline = () => {
  const { loadingUserData, dataError, refreshData } = useData();

  // Modal state for editing assets/liabilities from activity feed
  const [isEditing, setIsEditing] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [editingType, setEditingType] = useState(null);

  const editEntry = (item, type) => {
    setIsEditing(true);
    setEditingItem(item);
    setEditingType(type);
  };

  const cancelEntry = () => {
    setIsEditing(false);
    setEditingItem(null);
    setEditingType(null);
  };

  if (loadingUserData) return <LoadingScreen />;
  if (dataError) return <LoadingScreen error={dataError} onRetry={refreshData} />;

  return (
    <div className="TimelinePage">
      <Navigation />
      <div className="Container">
        <HistoryPanel />
        <ActivityPanel onItemClick={editEntry} />
        <MilestonesPanel />
      </div>

      {/* Editing Modal for Assets/Liabilities */}
      {isEditing && (
        <SideDrawer onCancel={cancelEntry}>
          <EditPanel
            type={editingType}
            isNew={false}
            item={editingItem}
            onCancelHandler={cancelEntry}
          />
        </SideDrawer>
      )}
    </div>
  );
};

export default Timeline;
